import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import {
  AccountsService,
  CreatePaymentCommand,
  PaymentsService,
  PurchaseInvoicesService
} from '@api-accounting-client';
import { Observable } from 'rxjs';

import { AppNavigationService } from '../../../shared/services/app';
import { DialogExtendedService, NotificationsExtendedService } from '../../../shared/services';
import { IssuePaymentFormBaseComponent } from '../issuePaymentFormBaseComponent';

@Component({
    selector: 'app-issue-payment-add',
    templateUrl: './issue-payment-add.component.html',
    styleUrls: ['./issue-payment-add.component.scss'],
    standalone: false
})
export class IssuePaymentAddComponent
  extends IssuePaymentFormBaseComponent
  implements OnInit, AfterViewInit, OnDestroy {  
  constructor(
    protected appNavigationService: AppNavigationService,
    protected formBuilder: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
    protected paymentsService: PaymentsService,
    protected accountsService: AccountsService,
    protected purchaseInvoicesService: PurchaseInvoicesService,
    protected dialogExtendedService: DialogExtendedService,
    protected notificationsExtendedService: NotificationsExtendedService,
  ) {
    super(
      appNavigationService,
      formBuilder,
      accountsService,
      purchaseInvoicesService,
      dialogExtendedService,
      notificationsExtendedService,
    );
  }

  onDataSubmit(command: CreatePaymentCommand): Observable<any> {
    return this.paymentsService.paymentsPost(command);
  }

  async ngOnInit() {
    super.ngOnInit();
  }
  
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  isAmountInvalid(field: string) {
    const control = this.form.controls[field];
    // Check if amount is 0 or less than sum of payments 
    return (
      (control.value <= 0 ||
        control.value < this.invoicesGrid?.totalPayment[field]) &&
      !control.pristine
    );
  }
  
  isAmountRequired(field: string) {
    return this.form.controls[field]?.errors?.required;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
